export enum EvaluationModuleState {
  SCHEDULED = 'SCHEDULED',
  ACTIVATED = 'ACTIVATED',
  CLOSED = 'CLOSED'
}
